module.exports = __webpack_public_path__ + "static/casferlogo-abe39e3c08e1596dd8abdc2ac2b787e5.png";